import React from "react";

import Box from "../components/box/index.js";

import styles from "./styles.module.scss";

const Icon = ({ icon, size = "small", ...props }) => {
  const otherProps = {
    "data-icon": icon
  };

  return (
    <Box
      className={styles.icon}
      element="span"
      profiling="borderless"
      size={size}
      {...props}
      {...otherProps}
    />
  );
};

const ArrowLeftIcon = (props) => {
  return <Icon icon="arrow-left" {...props} />;
};

const ArrowRightIcon = (props) => {
  return <Icon icon="arrow-right" {...props} />;
};

const CrescentIcon = (props) => {
  return <Icon icon="crescent" {...props} />;
};

const MenuIcon = (props) => {
  return <Icon icon="menu" {...props} />;
};

const SunIcon = (props) => {
  return <Icon icon="sun" {...props} />;
};

const Icons = {
  ArrowLeftIcon,
  ArrowRightIcon,
  CrescentIcon,
  MenuIcon,
  SunIcon
};

export default Icons;
